import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ListContractDigitizationBusinessComponent} from './list-contract/list-contract-business.component';
import {AddContractDigitizationBusinessComponent} from './add-contract/add-contract.component';


const routes: Routes = [
  {
    path: '',
    component: ListContractDigitizationBusinessComponent
  },
  {
    path: 'create',
    component: AddContractDigitizationBusinessComponent,
    data: {
      breadcrumb: ['breadcrumbs.document_digitization_create'],
    }
  },
  {
    path: ':contractID/update',
    component: AddContractDigitizationBusinessComponent,
    data: {
      breadcrumb: ['breadcrumbs.document_digitization_update'],
    }
  },
  {
    path: ':contractID/view',
    component: AddContractDigitizationBusinessComponent,
    data: {
      breadcrumb: ['breadcrumbs.document_digitization_view'],
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContractDigitizationBusinessRoutingModule { }
